import React, { Component } from 'react'
import { connect } from 'react-redux'
import { translate } from 'react-i18next'
import { Accordion } from 'semantic-ui-react'

class AccordionContent extends Component {
  constructor(props) {
    super(props);
    this.state = {openKeys: {}};
    this.getPanelContent = this.getPanelContent.bind(this);
    this.handleTitleClick = this.handleTitleClick.bind(this);
  }

  handleTitleClick(key,itemProps) {
    const { active } = itemProps;
    let newKeyState = this.state.openKeys;
    newKeyState[key] = active ? -1 : 0;
    this.setState({openKeys: newKeyState});
  }

  getPanelContent(data, isOpen) {
    if (Object.keys(data).length === 0) {
      return (
        <div>
          <p style={{marginBottom:'0'}} key={"unkeyed" + Math.random()}>Not Applicable
          </p>
        </div>
      )
    } else {
      return (
        <div>
          {
            Object.keys(data).sort((a,b) => {
              return a.localeCompare(b, undefined, { sensitivity: 'base'})
            }).map((key,idx) => {
              let value = data[key];
              let myIsOpen = isOpen;
              if (this.state.openKeys.hasOwnProperty(key+idx)) {
                myIsOpen = this.state.openKeys[key+idx];
              } 
              if (value === null) {
                return (
                  <p style={{marginBottom:'0'}} key={key+idx}>
                    <span style={{fontWeight:'bold',fontSize:'1.2em'}}>{key}:</span> Not Applicable
                  </p>
                );
              } else if (value.constructor === Object || Array.isArray(value)) {
                return (
                  <Accordion key={key+idx} styled style={{width: "100%"}} panels={[
                    {key:key, title:key, content: { content: this.getPanelContent(value,myIsOpen)}}
                  ]}
                    activeIndex = {myIsOpen == null ? -1 : myIsOpen }
                    onTitleClick={(e,itemProps) => this.handleTitleClick(key+idx,itemProps)}
                  />
                )
              }
              return (
                <p style={{marginBottom:'0'}} key={key+idx}>
                  <span style={{fontWeight:'bold',fontSize:'1.2em'}}>{key}:</span> {value.toString()}
                </p>
              );
            })
          }
        </div>
      );
    }
  }

  render() {
    const { t } = this.props;
    if (!this.props.callDetail || Object.keys(this.props.callDetail).length === 0) {
      return null;
    }
    return (
      <div style={{paddingBottom: "5px"}}>
        <Accordion styled defaultActiveIndex={0} style={{width: "100%"}} panels={[
          {
            key:'root', 
            title:t("Screens.Calls.CallDetail.Details"), 
            content: { content: this.getPanelContent(this.props.callDetail)}
          }
        ]}
        />
      </div>
    )
  }
}

// REDUX STATE
const mapToProps = state => {
  return {
    //    packetData: state.packetData.raw
  }
};

export default translate()(
  connect(
    mapToProps,
    null
  )(AccordionContent)
);
